module.exports = __webpack_public_path__ + "static/media/8. Intromisión, Mixta sobre madera, 95 x 120 cm, 2012 copy.30d050b1.png";